import { render, staticRenderFns } from "./date-update-modal.vue?vue&type=template&id=52240e62&scoped=true"
import script from "./date-update-modal.vue?vue&type=script&lang=js"
export * from "./date-update-modal.vue?vue&type=script&lang=js"
import style0 from "./date-update-modal.vue?vue&type=style&index=0&id=52240e62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52240e62",
  null
  
)

export default component.exports